import vueAppInitiator from '@/js/modules/vue-app-initiator';
import StepsSlider from '@/js/vue-components/pages/StepsSwitcherFullWidth';
import ElRegLibraryForm from '@/js/vue-components/ElRegLibraryForm';
import TabsComponent from '@/js/vue-components/ui/TabsComponent';
import TabComponent from '@/js/vue-components/ui/TabComponent';
import smoothScroll from '../../../modules/sm-scroll-with-nav';

const vueApps = [
    {
        el: '#steps-switcher',
        components: {
            StepsSlider
        }
    },
    {
        el: '#el_reg_library',
        components: {
            ElRegLibraryForm
        }
    },
    {
        el: '#tab-component',
        components: {
            TabsComponent,
            TabComponent
        }
    }
];

document.addEventListener('DOMContentLoaded', () => {
    vueAppInitiator(vueApps);
    smoothScroll();
});
